var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-menu__copy",on:{"click":_vm.copyUrlToClipboard}},[_c('svg',{attrs:{"width":"24","height":"24","color":"rgba(255, 255, 255, 0.8)","fill":"none"}},[_c('use',{attrs:{"xlink:href":require("@/assets/sprites/icons.svg") + "#attachment"}})]),_c('span',[_vm._v("Copy Link")])])
}
var staticRenderFns = []

export { render, staticRenderFns }